// extracted by mini-css-extract-plugin
module.exports = {"loading":"AccountPopup_loading__o8CXK","account":"AccountPopup_account__pKQct","footer":"AccountPopup_footer__yzLIa"};